import React from 'react'
import { useSelector } from 'react-redux'
import { Breadcrumb } from '../../../components'
import { formatDate } from '../../../utils'

const minReadLabel = {
  en: 'min read',
  id: 'menit dibaca'
}

const HeadComponent = ({isNotExist, data}) => {
  const language = useSelector(state => state.system.language)
  console.log('HEAD COMPONENT DATA', data)
  const { title, category = {}, /* category_id */ } = data

  const routes = [
    {
      name: 'Home',
      route: '/'
    },
    {
      name: 'Blog',
      route: '/blog'
    },
    {
      name: category[language.name],
      // @todo check how blog category works
      // route: `/blog?category=${category_id}`
      route: '#'
    }
  ]

  const titleRendered = title ? (typeof title === 'string' ? title : (title[language.name] ? title[language.name] : JSON.stringify(title))) : 'Gerakan #SalingJaga: Bantu Ekonomi Warga Terdampak Covid-19 di Bandung Raya'
  const date = data.date ? formatDate(data.date) : 'Jun 26, 2020'
  const minute_read = data.minute_read ? data.minute_read : 'Jun 26, 2020'

  return (
    <div>
      <Breadcrumb className="mb-1 lg:mb-5" routes={routes} />
      <h1 className="text-2xl lg:text-4xl font-bold lg:leading-tight lg:mb-8 font-primary">
        {titleRendered}
      </h1>
      <p className="mt-3 mb-6 lg:mt-10 lg:mb-10 text-sm text-gray-444">
        • {date} • {minute_read} {minReadLabel[language.name]}
      </p>
      <hr className="lg:hidden mb-4"/>
    </div>
  )
}

export { HeadComponent }
